import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/eu-readiness-cardiology")({
  head: () => buildRouteHead("/eu-readiness-cardiology", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/eu-readiness-cardiology", replace: true });
  },
});
